import React from 'react';
import PropTypes from 'prop-types';

import styles from './TextLoader.module.scss';

const TextLoader = ({ rows, rowsColor }) => (
  <div className={styles.rowsWrapper} data-testid="text-loader">
    {[...new Array(rows)].map((arr, index) => (
      <div className={[styles.loading, styles[rowsColor]].join(' ')} key={index} />
    ))}
  </div>
);

TextLoader.propTypes = {
  rows: PropTypes.number,
  rowsColor: PropTypes.string
};

TextLoader.defaultProps = {
  rows: 3,
  rowsColor: ''
};

export default TextLoader;
